module.exports = __webpack_public_path__ + "static/media/om_beard_shortboxed_long__square_vector.6da04882.svg";